import svg from './row-svg/employee-en-charge.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function EmployeeEnChargeIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default EmployeeEnChargeIcon;
